import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/home.vue'
import { siteCanonical } from '@/constants/site'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

const link = (path) => [{ rel: 'canonical', href: siteCanonical(path) }]

const blogArticles = [
	{
		path: '/is-gb-whatsapp-old-version-worth-using/',
		name: 'en-gb-whatsapp-old-version',
		title: 'GB WhatsApp Old Version: Is It Still Worth Using?',
		description:
			'Wondering why users still choose an old GB WhatsApp version? Learn the benefits, drawbacks, compatibility issues, and when an older build makes sense.',
		slug: 'old-version',
	},
	{
		path: '/why-use-gb-whatsapp-instead-of-official-app/',
		name: 'en-why-use-gb-whatsapp',
		title: 'Why Do People Use GB WhatsApp Instead of WhatsApp?',
		description:
			'Discover why some users choose GB WhatsApp for extra privacy controls, customization, and messaging features, and what trade-offs to consider.',
		slug: 'why-use',
	},
]

const articleRoutes = blogArticles.map((article) => ({
	path: article.path,
	name: article.name,
	meta: {
		appname: 'GBWhatsApp',
		title: article.title,
		keywords: 'GB WhatsApp, GB WhatsApp blog, GB WhatsApp guide',
		description: article.description,
		link: link(article.path),
		articleSlug: article.slug,
	},
	component: () => import('@/views/blog-article.vue'),
}))

/**
 * 注意：Vue Router 3 默认不严格区分尾部斜杠，/download 会匹配 /download/。
 * 若先注册 redirect('/download' -> '/download/')，访问 /download/ 会一直命中 redirect 形成死循环。
 * 必须先注册带 / 的正式路由，再注册无斜杠的 redirect。
 */
export const constRoutesPc = [
	{
		path: '/',
		name: 'en-gb',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp APK New Version Download v18.80 Updated 2026',
			keywords: 'GB WhatsApp, GB WhatsApp APK',
			description:
				"Looking for GB WhatsApp APK New Version Download? It's a modified version of the official app. Download GBWhatsApp app to enjoy extra features.",
			link: link('/'),
		},
		component: Home,
	},
	{
		path: '/download/',
		name: 'en-download',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Page to Get GB WhatsApp APK File 2026',
			keywords: 'GB WhatsApp APK, GB WhatsApp latest version, install GB WhatsApp',
			description:
				'Click the download button to get the latest GBWhatsApp APK file. Our page provides apk files for Android users.',
			link: link('/download/'),
		},
		component: () => import('@/views/download.vue'),
	},
	{ path: '/download', redirect: '/download/' },
	{
		path: '/blog/',
		name: 'en-blogs',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Blog - Tips, Updates & Helpful Guides',
			keywords: 'GB WhatsApp blog, GB WhatsApp tips, GB WhatsApp updates',
			description:
				'Read GB WhatsApp tips, version insights, feature updates, comparisons, and practical information to help you make better choices.',
			link: link('/blog/'),
		},
		component: () => import('@/views/blogs.vue'),
	},
	{ path: '/blog', redirect: '/blog/' },
	...articleRoutes,
	{
		path: '/guides/',
		name: 'en-guides',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Tutorials ‒ Install, Update, Backup & Fix Issues',
			keywords:
				'GB WhatsApp tutorials, GB WhatsApp how-to, GB WhatsApp guide, GB WhatsApp update, GB WhatsApp backup, GB WhatsApp troubleshooting, GB WhatsApp tips',
			description:
				'Learn how to install, update, and use GB WhatsApp safely. Step-by-step guides, backup tips, customization, privacy settings, and troubleshooting included.',
			link: link('/guides/'),
		},
		component: () => import('@/views/guides.vue'),
	},
	{ path: '/guides', redirect: '/guides/' },
	{
		path: '/comparison/',
		name: 'en-comparison',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp vs WhatsApp & Other Mods ‒ Features, Safety & Updates',
			keywords:
				'GB WhatsApp vs WhatsApp, GB WhatsApp comparison, GB WhatsApp vs FMWhatsApp, GB WhatsApp vs YoWhatsApp, GB WhatsApp features, GB WhatsApp safety',
			description:
				'Compare GB WhatsApp with official WhatsApp, FMWhatsApp, and YoWhatsApp. Features, privacy, performance, stability, and update differences explained clearly.',
			link: link('/comparison/'),
		},
		component: () => import('@/views/comparison.vue'),
	},
	{ path: '/comparison', redirect: '/comparison/' },
	{
		path: '/features/',
		name: 'en-features',
		meta: {
			appname: 'GBWhatsApp',
			title: 'GB WhatsApp Features ‒ Privacy, Customization & Messaging Tools',
			keywords:
				'GB WhatsApp features, GB WhatsApp privacy, GB WhatsApp customization, GB WhatsApp messaging tools, GB WhatsApp DND mode, GB WhatsApp auto-reply',
			description:
				'Explore GB WhatsApp features: privacy settings, anti-delete messages, themes, large media sharing, DND mode, auto-reply, and app lock tools explained in detail.',
			link: link('/features/'),
		},
		component: () => import('@/views/features.vue'),
	},
	{ path: '/features', redirect: '/features/' },
	{
		path: '/privacy/',
		name: 'en-privacy',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Privacy Policy | GB WhatsApp Guide | gbofficial.net',
			keywords: 'GB WhatsApp, privacy policy, gbofficial.net',
			description: 'Privacy Policy for gbofficial.net. How we handle information when you use our GB WhatsApp guides and download resources.',
			link: link('/privacy/'),
		},
		component: () => import('@/views/privacy.vue'),
	},
	{ path: '/privacy', redirect: '/privacy/' },
	{
		path: '/about-us/',
		name: 'en-about-us',
		meta: {
			appname: 'GBWhatsApp',
			title: 'About Us | gbofficial.net',
			keywords: 'gbofficial.net about us, GB WhatsApp information',
			description:
				'Learn about gbofficial.net, an independent information site sharing GB WhatsApp guides, updates, and educational resources.',
			link: link('/about-us/'),
		},
		component: () => import('@/views/about-us.vue'),
	},
	{ path: '/about-us', redirect: '/about-us/' },
	{
		path: '/disclaimer/',
		name: 'en-disclaimer',
		meta: {
			appname: 'GBWhatsApp',
			title: 'Disclaimer | gbofficial.net',
			keywords: 'GB WhatsApp disclaimer, gbofficial.net disclaimer',
			description:
				'Read the gbofficial.net disclaimer about independent GB WhatsApp information, third-party links, and unofficial app content.',
			link: link('/disclaimer/'),
		},
		component: () => import('@/views/disclaimer.vue'),
	},
	{ path: '/disclaimer', redirect: '/disclaimer/' },
]

const routes = constRoutesPc

export default function createRouter() {
	return new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			}
			return { x: 0, y: 0 }
		},
	})
}
